var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-pixellot-loading",class:{ fullscreen: _vm.fullscreen }},[(_vm.fullscreen)?_c('loading-fullscreen'):(_vm.circle)?_c('loading-circle'):_c('loading-regular')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }